import { CancelFlightItineraryState } from './cancelFlightItinerary.types'

const initialState: CancelFlightItineraryState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
